var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.534 20.534c-.076-.024-1.41-.473-1.443-.48a4.931 4.931 0 0 1-6.52 0l-1.437.48a3.346 3.346 0 0 0-2.288 3.142c.003.164-.018 1.612.023 1.738a1.343 1.343 0 0 0 1.297 1.082c2.873.002 11.103-.002 11.335 0a1.324 1.324 0 0 0 1.32-1.32v-1.47a3.346 3.346 0 0 0-2.287-3.172z",
    fill: "#F1D131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.749 19.66c2.462 1.675 6.038-.272 5.971-3.27a3.905 3.905 0 0 0-3.889-3.89c-3.858-.001-5.329 5.115-2.082 7.16z",
    fill: "#F1D131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.155 12.066a10.578 10.578 0 0 0-10.506-9.457c-14.206.521-13.835 21.004.174 21.068a4.38 4.38 0 0 1 2.989-4.114l1.013-.338c-2.947-4.218 1.77-9.58 6.33-7.16zm-9.994 1.11a.51.51 0 0 1-.154.364L8.69 17.864a.514.514 0 0 1-.727-.727l4.175-4.17V5.07a.512.512 0 1 1 1.024 0v8.105z",
    fill: "#F1D131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f24a3d44a440ef214d78b6de83fb7278.svg";
export { ForwardRef as ReactComponent };